import { render } from "./ProfileQualifications.vue?vue&type=template&id=67460a74&scoped=true"
import script from "./ProfileQualifications.vue?vue&type=script&lang=js"
export * from "./ProfileQualifications.vue?vue&type=script&lang=js"

import "./ProfileQualifications.vue?vue&type=style&index=0&id=67460a74&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67460a74"]])

export default __exports__